"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeLayoutColumn = void 0;
var slate_1 = require("slate");
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var resizeLayoutColumn = function (editor, path, _a) {
    var columnIndex = _a.columnIndex, distance = _a.distance;
    var _b = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _b[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var leftColumnData = data.columns[columnIndex];
    var rightColumnData = data.columns[columnIndex + 1];
    (0, tiny_invariant_1.default)(!!leftColumnData, "no data for left column");
    (0, tiny_invariant_1.default)(!!rightColumnData, "no data for right column");
    leftColumnData.width += distance;
    rightColumnData.width -= distance;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.resizeLayoutColumn = resizeLayoutColumn;
